export enum SortOrder
{
    None = 0,
    Asc,
    Desc
}

export class SortedField
{
    static get empty(): SortedField
    {
        return new SortedField("", SortOrder.None);
    }

    constructor(public readonly caption: string, public readonly order: SortOrder) { }
}

export function sort(order: SortOrder): SortOrder
{
    if (order === SortOrder.None) return SortOrder.Asc;
    if (order === SortOrder.Asc) return SortOrder.Desc;
    return SortOrder.None;
}